// extracted by mini-css-extract-plugin
export var brand_button = "styles-module--brand_button--11ae6";
export var container = "styles-module--container--7b6c5";
export var extended_buttons_closed = "styles-module--extended_buttons_closed--fa025";
export var extended_buttons_open = "styles-module--extended_buttons_open--43e3a";
export var footer = "styles-module--footer--f48a9";
export var header = "styles-module--header--211ed";
export var image_container = "styles-module--image_container--e0d18";
export var location_label = "styles-module--location_label--20736";
export var tag_button = "styles-module--tag_button--4eb5e";
export var tag_is_closed = "styles-module--tag_is_closed--f09d5";
export var tag_is_open = "styles-module--tag_is_open--19348";
export var text_container = "styles-module--text_container--4a15c";
export var type_button = "styles-module--type_button--e2906";